var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCouples(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "budicon-shared-user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st0",
    d: "M11.3,8c-0.5,0-0.9,0.1-1.3,0.2c2.3,0.6,4,2.7,4,5.1s-1.7,4.5-4,5.1c0.4,0.1,0.9,0.2,1.3,0.2 c2.9,0,5.3-2.4,5.3-5.3S14.3,8,11.3,8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    d: "M14.4,19.2c2.1-1.1,3.6-3.3,3.6-5.9c0-3.7-3-6.7-6.7-6.7s-6.7,3-6.7,6.7c0,2.6,1.5,4.8,3.6,5.9 C4.6,20.5,2,24.6,2,28.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7c0-4.4,3.6-8.7,8-8.7s8,4.3,8,8.7c0,0.4,0.3,0.7,0.7,0.7 s0.7-0.3,0.7-0.7C20.7,24.6,18.1,20.5,14.4,19.2z M6,13.3C6,10.4,8.4,8,11.3,8s5.3,2.4,5.3,5.3s-2.4,5.3-5.3,5.3S6,16.3,6,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    d: "M28.2,16.5c1.5-0.9,2.5-2.6,2.5-4.5c0-2.9-2.4-5.3-5.3-5.3S20,9.1,20,12c0,1.9,1,3.5,2.5,4.5 c-1.8,0.6-3.3,1.8-4.3,3.3c0.3,0.3,0.7,0.6,1,0.9c1.3-2.1,3.6-3.4,6.2-3.4c4,0,7.3,3.3,7.3,7.3c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7C34,20.9,31.6,17.7,28.2,16.5z M21.3,12c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S21.3,14.2,21.3,12z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st0",
    d: "M25.3,8c-0.5,0-0.9,0.1-1.3,0.2c1.5,0.6,2.7,2,2.7,3.8s-1.1,3.2-2.7,3.8 c0.4,0.1,0.9,0.2,1.3,0.2c2.2,0,4-1.8,4-4S27.5,8,25.3,8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCouples);
export default __webpack_public_path__ + "static/media/icon-couples.b29f5a693f6ee93a2740ca41527857c0.svg";
export { ForwardRef as ReactComponent };